import { Input, Label } from 'reactstrap'
import { FormItemProps } from './types'

const FormCheckbox = (props: FormItemProps) => {
    const { item } = props
    return (
        <div className="me-3">
            <Input type="checkbox" checked={false} readOnly></Input>
            <Label className="fs-12 ms-2">{item.field}</Label>
        </div>
    )
}

export default FormCheckbox
